import { Location } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "monitoring-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent {
  @Input() componentName;

  constructor(private _location: Location) {}

  goBack() {
    this._location.back();
  }
}
